import { createCustomEnum } from "./customEnum";

const FundingTypes = createCustomEnum({
	SameDay: {
		value: 0,
		name: "SameDay",
		displayName: "Same Day",
	},
	NextDay: {
		value: 1,
		name: "NextDay",
		displayName: "Next Day",
	},
	OneDayDelay: {
		value: 2,
		name: "OneDayDelay",
		displayName: "One Day Delay",
	},
});

export default FundingTypes;
